import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Label, Popup } from 'semantic-ui-react';

const INLINE_LIMIT = 5;
const linkLabelStyle = { textDecoration: 'underline' };
const moreStyle = { cursor: 'pointer' };
const popupStyle = { maxWidth: 520, maxHeight: 320, overflowY: 'auto' };

const renderTag = (ht = '', i) => (_.startsWith(ht, '@') ? (
  <a
    key={`${ht}-${i}`}
    href={`https://www.instagram.com/${ht.substring(1)}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    <Label basic color="blue" style={linkLabelStyle}>{ht}</Label>
  </a>
) : (
  <Label key={`${ht}-${i}`} basic color="grey">{ht}</Label>
));

const CampaignHashtagsHeader = ({ hashtags }) => {
  if (_.isEmpty(hashtags)) return null;
  const visible = _.take(hashtags, INLINE_LIMIT);
  const hidden = _.slice(hashtags, INLINE_LIMIT);
  return (
    <span className="campaign-hashtags-header">
      { _.map(visible, renderTag) }
      {
        !_.isEmpty(hidden) &&
        <Popup
          on="click"
          wide="very"
          position="bottom left"
          trigger={<Label basic color="grey" style={moreStyle}>{`+${_.size(hidden)} more`}</Label>}
          content={<div style={popupStyle}>{ _.map(hidden, renderTag) }</div>}
        />
      }
    </span>
  );
};

CampaignHashtagsHeader.propTypes = {
  hashtags: PropTypes.array,
};

CampaignHashtagsHeader.defaultProps = {
  hashtags: [],
};

export default CampaignHashtagsHeader;



/** WEBPACK FOOTER **
 ** ./src/components/campaign-hashtags-header/index.js
 **/